import './doctor.scss';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, CalendarDays, CircleUserRound, FileClock, Stethoscope } from 'lucide-react';
import DoctorPageHeader from './DoctorPageHeader';

const DOCTOR_PORTAL_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  'https://api.curenow.jp';

const QUICK_LINKS = [
  {
    title: 'カルテ・診察開始',
    description: '予約一覧から診察を開始してカルテを開く',
    href: `${DOCTOR_PORTAL_BASE_URL.replace(/\/$/, '')}/doctor/reservations/`,
    icon: Stethoscope,
    accentClass: 'doctor-home-link-card--blue'
  },
  {
    title: 'シフト管理',
    description: '提出状況と予定をまとめて確認',
    path: '/doctor/shifts',
    icon: CalendarDays,
    accentClass: 'doctor-home-link-card--amber'
  },
  {
    title: 'プロフィール',
    description: '基本情報と公開設定の更新',
    path: '/doctor/profile',
    icon: CircleUserRound,
    accentClass: 'doctor-home-link-card--mint'
  },
  {
    title: '診療履歴',
    description: '過去の診察内容を振り返る',
    path: '/doctor/history',
    icon: FileClock,
    accentClass: 'doctor-home-link-card--rose'
  }
];

const DoctorHomePage = () => {
  const navigate = useNavigate();

  return (
    <div className="doctor-home-page">
      <DoctorPageHeader title="医師ホーム" />

      <section className="doctor-home-section">
        <div className="doctor-home-link-grid">
          {QUICK_LINKS.map((link) => {
            const Icon = link.icon;

            return (
              <button
                key={link.path || link.href}
                type="button"
                className={`doctor-home-link-card ${link.accentClass}`}
                onClick={() => {
                  if (link.href) {
                    window.location.assign(link.href);
                    return;
                  }

                  navigate(link.path);
                }}
              >
                <div className="doctor-home-link-card__icon">
                  <Icon size={20} />
                </div>
                <div className="doctor-home-link-card__body">
                  <span className="doctor-home-link-card__title">{link.title}</span>
                  <span className="doctor-home-link-card__description">{link.description}</span>
                </div>
                <ArrowRight size={16} className="doctor-home-link-card__arrow" />
              </button>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default DoctorHomePage;
